import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './UserInfoContainer.html?raw';

import _WidgetBaseSP from 'more/_WidgetBaseSP';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import lang from 'dojo/_base/lang';
import SimpleFileUpload from '../../../moreCore/UI/SimpleFileUpload/SimpleFileUpload';
import on from 'dojo/on';
import { TranslationHelpers } from "../../../more/Helpers";

class UserInfoContainer extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private userLabel: string;
    private userLabelNode: HTMLElement;

    private usertext: HTMLElement;
    private userDisplaytext: HTMLElement;
    private userInfoContainer: HTMLElement;

    private substituteUserInfoContainer: HTMLElement;
    private substituteUsertext: HTMLElement;

    private iconNode: HTMLElement;



    setUserLabel(label: string) {
        this.userLabel = label;
        this.userLabelNode.innerHTML = TranslationHelpers.tryTranslate(label) + ":";
    }

    protected _setUserLabelAttr(userLabel: string): void {
        this.setUserLabel(userLabel);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);


    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        if (window.sessionInfo?.sessionData) {
            this.setup();
        } else {
            this.addSubscription("/Session/Open", lang.hitch(this, this._onSessionUpdate));
            this.addSubscription("/Session/CheckForExistingSession", lang.hitch(this, this._onSessionUpdate));
        }
        if (window.sessionInfo.isSessionOpen()) this.setup();
    }

    private _onSessionUpdate(result) {
        if (window.sessionInfo.isSessionOpen()) {
            this.setup();
        } else {
            this.hideNode(this.domNode, true);
        }
    }

    setup(userLabel?: string) {
       
        if (userLabel) this.setUserLabel(userLabel);

        let actualUserName = window.sessionInfo.getUserName(true);
        let actualUserDisplay = window.sessionInfo.getUserDisplayName(true);
        if (actualUserDisplay == "" || actualUserDisplay == null || typeof (actualUserDisplay) == "undefined") {
            actualUserDisplay = actualUserName;
        }

        this.UiModder.domAttr.set(this.usertext, "innerHTML", actualUserName);
        this.UiModder.domAttr.set(this.userDisplaytext, "innerHTML", actualUserDisplay);
        this.UiModder.domClass.remove(this.userInfoContainer, "w3-hide");

        let isSubstitute = window.sessionInfo.isSubstitutionActive();
        let userDisplaySubst = window.sessionInfo.getUserDisplayName();
        this.hideNode(this.substituteUserInfoContainer, !isSubstitute);
        if (isSubstitute) {
            this.UiModder.domAttr.set(this.substituteUsertext, "innerHTML", userDisplaySubst);
        }


        window.sessionInfo.getProfilepicData(lang.hitch(this, this.setProfilePic));
    }

    private _profilePicUploadData: any = null;

    private _onClick_ProfilePic() {

        //if (!window.sessionInfo) {
        //    console.warn("cannot change profile pic - sessionInfo is not ready");
        //    return;
        //}

        let dlg = new GenericDialog();

        dlg._setHeaderAttr(this.translate("UserProfile__ChangeProfilePic"));
        dlg.closeOnEnter = false;
        dlg.destroyOnClose = false;

        dlg.set("callback", lang.hitch(this, this.profilePicDlgCallback, dlg));

        let container = this.UiModder.domConstruct.create("div", { "id": "profilePicDlg" });
        let imageContainer = this.UiModder.domConstruct.create("div", { "className": "profilePicContainer empty" }, container);
        let deleteBtnContainer = this.UiModder.domConstruct.create("div", { "className": "deleteButtonContainer w3-panel w3-block w3-center" }, container);

        let image = this.UiModder.domConstruct.create("img", {
            "src": "",
            "className": "profilePic"
        }, imageContainer);


        let deleteBtn = this.UiModder.domConstruct.create("button", {
            "className": "deleteButton mds-button-base round hoverBright tertiaryBG w3-hide",
            "innerHTML": this.translate("General_Remove")
        }, deleteBtnContainer);

        let deleteIcon = this.UiModder.domConstruct.create("i", { "className": "fas fa-times deleteIcon" }, deleteBtn, "first");

        let upload = new SimpleFileUpload();
        this.UiModder.domClass.add(upload.domNode, "w3-block w3-panel hidden");
        upload.placeAt(container);
        upload.on("change", lang.hitch(this, this._serializeProfilePicData, upload, deleteBtn, image, imageContainer, dlg));
        upload.startup();

        on(deleteBtn, "click", lang.hitch(this, this.removeProfilePic, deleteBtn, image, imageContainer, upload, dlg));
        on(imageContainer, "click", lang.hitch(upload, upload.click));

        if (window.sessionInfo) {
            let data = window.sessionInfo.getProfilepicData()
            //console.debug("_onClick_ProfilePic current profiledata", data);
            if (data) {
                if (data.base64) {
                    //setUserdefinedButton(text: string, iconClass: string, callback: Function, bCloseOnClick?: boolean, bSecondaryButton?: boolean)
                    //dlg.setUserdefinedButton("entfernen", "fas fa-trash-alt", lang.hitch(this, this.removeProfilePic), false, true);

                    this.UiModder.domClass.remove(imageContainer, "empty");
                    this.UiModder.domAttr.set(image, "src", "data:image/jpeg;base64," + data.base64);
                    this.UiModder.domClass.remove(deleteBtn, "w3-hide");

                    //let input = 
                }
                else {
                    upload.click();
                }
            }
        }


        //dlg.show();
        dlg.show(null, this.translate("UserProfile__ChangeProfilePic"), null, null, "close");
        dlg.addNodeToContent(container);


    }

    private _serializeProfilePicData(fileUpload, deleteBtn, image, imageContainer, dlg) {
        let data = fileUpload.getUploadData();
        this._profilePicUploadData = data;
        //console.debug("_serializeProfilePicData", data);

        if (data) {
            if (data.files) {
                if (data.files[0].Base64Content) {
                    this.UiModder.domAttr.set(image, "src", data.files[0].Base64Content);
                    this.UiModder.domClass.add(image, "changed");
                    this.UiModder.domClass.remove(imageContainer, "empty");
                    this.UiModder.domClass.remove(deleteBtn, "w3-hide");
                }
            }
        }



        dlg.set("closeBtn", false);
        dlg.set("cancelBtn", true);
        dlg.set("okBtn", true);
    }

    private profilePicDlgCallback(dlg, result) {
        //console.debug("profilePicDlgCallback", result);

        if (result >= 1) {
            //domClass.add(dlg.domNode, "w3-disabled");
            this.uploadProfilePic(dlg);
        } else {
            dlg.destroy();
        }
    }

    private removeProfilePic(deleteBtn, image, imageContainer, upload, dlg, evt) {
        if (evt) {
            evt.stopPropagation();
        }

        upload.reset();

        console.debug("removeProfilePic");
        this.UiModder.domClass.add(deleteBtn, "w3-hide");
        this.UiModder.domAttr.set(image, "src", "");
        this.UiModder.domClass.add(imageContainer, "empty");

        this._profilePicUploadData = null;

        dlg.set("closeBtn", false);
        dlg.set("cancelBtn", true);
        dlg.set("okBtn", true);
    }

    private uploadProfilePic(dlg: MdsLax<InstanceType<typeof GenericDialog>>) {

        this.StandbyStart();

        let url = window.appRoot + "Home/UploadWebuserProfilePic";

        let data = { "webuserID": window.sessionInfo.getCurrentWebuserId(true), "data": this._profilePicUploadData };

        this.RequestManager.post(url,
            {
                "jsonData": JSON.stringify(data)
            },
            lang.hitch(this, this._onUploadProfilePicResponse, dlg),
            lang.hitch(this, this._onUploadProfilePicError, dlg)
        )
    }

    private _onUploadProfilePicResponse(dlg: MdsLax<InstanceType<typeof GenericDialog>>, response) {
        this.StandbyStop();

        dlg.destroy();

        //this.StandbyStart();

        window.sessionInfo.checkForExistingSession();
    }

    private _onUploadProfilePicError(dlg: MdsLax<InstanceType<typeof GenericDialog>>, error: more.requestErrorMessage) {
        alert("error uploading profile pic:\r\n" + error.Message);

        //domClass.remove(dlg.domNode, "w3-disabled");
        dlg.show();

        this.StandbyStop();
    }

    private setProfilePic(data) {

        //if (data) {
        //    console.debug("loginform setprofilpic", data.checksum);
        //}

        let userIcon = this.iconNode;

        if (userIcon) {
            this.UiModder.domConstruct.empty(userIcon);
        }

        if (data) {
            if (userIcon && data.base64) {
                let picOverlay = this.UiModder.domConstruct.create("img", {
                    "src": "data:image/jpeg;base64," + data.base64,
                    "className": "profilePic round"
                }, userIcon);
            }
        }
    }
}

export default mdsWidget(UserInfoContainer);